<!-- 由 woniu6162 创建于 2019-08-22 星期四 -->
<template>
  <div>
    <div class="food-details" v-if="detailData.name">
      <div class="food_wrap">
        <img :src="detailData.image" />
        <div class="f_w_info">
          <div class="w_i_wrap">
            <div class="i_w_name">{{ detailData.name }}</div>
            <div class="i_w_calory">
              {{ `${detailData.calorie.cal}kcal/100g` }}
            </div>
          </div>
        </div>
      </div>
      <div class="n_w_title">
        <div class="f_box">营养元素</div>
        <div class="s_box">每100g</div>
        <div class="t_box">备注</div>
      </div>
      <div class="nutrient_wrap">
        <template v-for="(item, index) in this.list1">
          <div :key="item.name" class="n_w_banner">
            <div class="f_box">{{ item.name }}</div>
            <div class="s_box">{{ !item.value ? '—' : item.value }}</div>
            <div class="t_box">{{ item.mark }}</div>
          </div>
        </template>
      </div>
      <div class="n_w_title n_w_title_2">维生素</div>
      <div class="nutrient_wrap">
        <template v-for="(item, index) in this.list2">
          <div :key="item.name" class="n_w_banner">
            <div class="f_box">{{ item.name }}</div>
            <div class="s_box">{{ !item.value ? '—' : item.value }}</div>
            <div class="t_box">{{ item.mark }}</div>
          </div>
        </template>
      </div>
      <div class="n_w_title n_w_title_2">矿物质</div>
      <div class="nutrient_wrap">
        <template v-for="(item, index) in list3">
          <div :key="item.name" class="n_w_banner">
            <div class="f_box">{{ item.name }}</div>
            <div class="s_box">{{ !item.value ? '—' : item.value }}</div>
            <div class="t_box">{{ item.mark }}</div>
          </div>
        </template>
      </div>
      <!-- <div
      class="n_w_open"
      :class="{ n_w_close: isPull }"
      @click="isPull = !isPull"
    >
        <v-svg icon="iconxuanzegengduo" />
        <span>{{ this.isPull ? '收起' : '展开' }}</span>
      </div>
    </div> -->
      <!-- <div class="food_analyse_wrap">
      <div class="a_w_title">食物解析</div>
      <div class="a_w_body">
        <img :src="detailData.thumb_image_url">
        <div class="w_b_right">
          <div class="b_r_top">
            <template v-if="detailData.health_light==1">
              <div
                class="w_i_light"
                style="color:#dc0050;"
              >推荐</div>
            </template>
            <template v-if="detailData.health_light==2">
              <div
                class="w_i_light"
                style="color:#f9a600;"
              >适量</div>
            </template>
            <template v-if="detailData.health_light==3">
              <div
                class="w_i_light"
                style="color:#bbb;"
              >不推荐</div>
            </template>
          </div>
          <div class="b_r_down">{{JSON.stringify(this.detailData)!="{}"?this.detailData.health[0].appraise:""}}</div>
        </div>
      </div>
    </div> -->
    </div>
    <van-loading
      class="v-loading"
      v-if="!loaded"
      text-color="#888888"
      color="#888888"
      vertical
      >加载中...</van-loading
    >
  </div>
</template>

<script>
export default {
  name: 'calorie-query-details',

  mixins: [],

  components: {},

  props: {},

  data() {
    return {
      loaded: false,
      isPull: false,
      foodid: this.$route.query.foodid,
      detailData: {},
      list1: [], // 营养元素
      list2: [], // 维生素
      list3: [] // 矿物质
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {
    this.getDetailInfo()
  },

  beforeRouteEnter(to, from, next) {
    if (to.query.name) {
      document.title = to.query.name
    }
    next()
  },

  destroyed() {},

  methods: {
    // 获取食物详情
    getDetailInfo() {
      this.$http
        .getApp('facility/calorie/FoodDetail', {
          foodid: this.$route.query.foodid
        })
        .then((rs) => {
          if (rs.data.code === 200) {
            this.detailData = rs.data.data
            document.title = this.detailData.name
            this.list1 = this.detailData.nutrition.more.filter((v) => {
              return v.type * 1 === 0
            })
            this.list2 = this.detailData.nutrition.more.filter((v) => {
              return v.type * 1 === 1
            })
            this.list3 = this.detailData.nutrition.more.filter((v) => {
              return v.type * 1 === 2
            })
          } else {
            this.$dialog.alert({
              title: '提示',
              message: res.data.msg
            })
          }
        })
        .finally(() => {
          this.loaded = true
        })
    },
    getDataThree() {
      let params = {
        a: 'getCaloris',
        token: 'ooi1CwIMBGX-WRE0SNHUO7hj3-2w',
        foodid: this.foodid
      }
      this.http.get(
        'member/index',
        params,
        (rs) => {
          if (rs.data.code === 200) {
            this.detailData = rs.data.data[0]
            console.log(this.detailData, 'this.detailData')
            let obj = rs.data.data[0]
            this.list1 = [
              {
                name: '热量（千卡）',
                value: obj.calory
              },
              {
                name: '蛋白质（克）',
                value: obj.protein
              },
              {
                name: '脂肪（克）',
                value: obj.fat
              },
              {
                name: '碳水化合物（克）',
                value: obj.carbohydrate
              },
              {
                name: '胆固醇（毫克）',
                value: obj.cholesterol
              }
            ]
            this.list2 = [
              {
                name: '纤维素（克）',
                value: obj.fiber_dietary
              },
              {
                name: '纤维素A（微克）',
                value: obj.vitamin_a
              },
              {
                name: '纤维素C（毫克）',
                value: obj.vitamin_c
              },
              {
                name: '纤维素E（毫克）',
                value: obj.vitamin_e
              }
            ]
            this.list3 = [
              {
                name: '铁（毫克）',
                value: obj.iron
              },
              {
                name: '钾（毫克）',
                value: obj.kalium
              },
              {
                name: '镁（毫克）',
                value: obj.magnesium
              },
              {
                name: ' 钠（毫克）',
                value: obj.natrium
              },
              {
                name: '烟酸（毫克）',
                value: obj.niacin
              },
              {
                name: '硒（毫克）',
                value: obj.selenium
              },
              {
                name: '锌（毫克）',
                value: obj.zinc
              }
            ]
          } else {
            this.$dialog.alert({
              title: '提示',
              message: res.data.msg
            })
          }
          this.loaded = true
        }
        // err => {
        //   console.log(err);
        //   MessageBox.alert("网络错误").then(a => {
        //     location.href = location.href.split("#")[0] + "?path=member";
        //   });
        // Indicator.close()
        // }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.food-details {
  min-height: 100vh;
  background-color: #fff;
  padding-bottom: 10vw;
  .food_wrap {
    padding: 0 4.3vw;
    display: flex;
    align-items: center;
    background-color: #fff;
    img {
      width: 16vw;
      height: 12vw;
      display: block;
    }
    .f_w_info {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 3vw 0 3vw 2.7vw;
      box-sizing: border-box;
      color: #3e4047;
      .w_i_wrap {
        text-align: left;
        .i_w_name {
          font-size: 4.3vw;
          line-height: 5.9vw;
        }
        .i_w_calory {
          font-size: 3.2vw;
          line-height: 4.5vw;
        }
      }
      .w_i_light {
        font-size: 3.6vw;
        min-width: fit-content;
      }
      svg {
        width: 5.3vw;
        height: 5.1vw;
      }
    }
  }
  .n_w_title {
    width: 100%;
    box-sizing: border-box;
    height: 9.6vw;
    padding: 0 8vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 3.2vw;
    color: #3b4761;
    background-color: #f3f4f7;
    position: sticky;
    top: -1px;
    & > div {
      width: 33%;
    }
    .f_box {
      text-align: left;
    }
    .s_box {
      text-align: center;
    }
    .t_box {
      text-align: right;
    }
  }
  .n_w_title_2 {
    font-weight: 600;
    color: #000;
    position: relative;
    top: 0;
  }
  // 营养元素
  .nutrient_wrap {
    padding: 0 8vw;
    background-color: #fff;
    .n_w_banner {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 3.2vw;
      color: rgba(0, 0, 0, 0.5);
      padding: 3.2vw 0;
      border-bottom: 0.3vw solid #f7f7f7;
      & > div {
        width: 33%;
      }
      .f_box {
        text-align: left;
      }
      .s_box {
        text-align: center;
      }
      .t_box {
        text-align: right;
      }
    }
    .n_w_open {
      display: flex;
      padding: 2.1vw 0 0;
      justify-content: center;
      align-items: center;
      font-size: 3.2vw;
      color: #bbb;
      position: relative;
      z-index: 300;
      & > svg {
        width: 3.5vw;
        height: 3.5vw;
        margin-right: 1.5vw;
      }
    }
    .n_w_close {
      & > svg {
        transform: rotate(180deg);
      }
    }
  }
  // 食物解析
  .food_analyse_wrap {
    text-align: left;
    padding: 3.2vw 4.3vw;
    background-color: #fff;
    margin-top: 2.7vw;
    .a_w_title {
      font-size: 4.3vw;
      color: #3e4047;
    }
    .a_w_body {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 3.2vw;
      img {
        width: 16.3vw;
        height: 16.3vw;
        display: block;
        border-radius: 50%;
      }
      .w_b_right {
        margin-left: 7.7vw;
        font-size: 3.2vw;
        .b_r_top {
          color: #dc0050;
          .w_i_light {
            font-size: 3.6vw;
          }
          svg {
            width: 4.8vw;
            height: 4.3vw;
          }
        }
        .b_r_down {
          margin-top: 1.3vw;
          color: #3e4047;
        }
      }
    }
  }
}
.v-loading {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}
</style>
